export default __webpack_public_path__ + "1135b4a4d44072f8aa9a38cb508c7803.png";